import { render, staticRenderFns } from "./collectConfirmation.vue?vue&type=template&id=532daf60&scoped=true"
import script from "./collectConfirmation.vue?vue&type=script&lang=js"
export * from "./collectConfirmation.vue?vue&type=script&lang=js"
import style0 from "./collectConfirmation.vue?vue&type=style&index=0&id=532daf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532daf60",
  null
  
)

export default component.exports